import React, { useContext } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import styles from './RadioQuestion.module.scss';
import { AnswersContext } from '../Survey';

export default function RadioQuestion({ _id, data }) {
    const {
        submitAnswer,
        answers: { [_id]: value },
    } = useContext(AnswersContext);

    return (
        <div>
            <FormGroup id={_id} className={styles.RadioQuestion}>
                {data.map((item, index) => (
                    <div key={index} className={`${styles.RadioAnswer} w-100`}>
                        <Input
                            type="radio"
                            id={_id + index}
                            name={_id}
                            title={item}
                            value={index}
                            checked={value === index}
                            onChange={(e) => submitAnswer(_id, parseInt(e.target.value))}
                            className="anl_survey--radio-input"
                        />
                        <Label for={_id + index}>{item}</Label>
                    </div>
                ))}
            </FormGroup>
        </div>
    );
}
